<template>
  <responsive-modal v-model="visible" title="Adicionar segmentação">
    <div class="tool-modal-leadlist">
      <div class="d-flex justify-content-center w-100">
        <snow-steps v-model="step" :steps="steps" fullWidth class="mb-4" />
      </div>
      <template v-if="visible">
        <step-1
          v-if="step === 1"
          :form="form"
          :errors="errors"
          :product_id="product_id"
          :provider="provider"
          @change-integration="clear"
        />

        <step-2-lead-lovers
          v-if="step === 2 && isLeadLovers"
          :form="form"
          :errors="errors"
          :product_id="product_id"
          :provider="provider"
          :is-signature="isSignature"
        />

        <step-2-active-campaign
          v-if="step === 2 && isActiveCampaign"
          :form="form"
          :errors="errors"
          :product_id="product_id"
          :provider="provider"
          :is-signature="isSignature"
        />

        <step-3
          v-if="step === 3"
          :form="form"
          :errors="errors"
          :provider="provider"
        />

        <resume v-if="step === 4" :form="form" />
      </template>

      <div class="snow-submit-buttons mt-6">
        <snow-button
          size="lg"
          class="order-lg-1"
          :text="submitLabel"
          :disabled="!isValid || loading"
          @click="next"
        />
        <snow-button
          variant="gray"
          :text="cancelLabel"
          size="lg"
          @click="previous"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";
import Resume from "./Resume.vue";
import Step1 from "./Step1.vue";
import Step2ActiveCampaign from "./Step2ActiveCampaign.vue";
import Step2LeadLovers from "./Step2LeadLovers.vue";
import Step3 from "./Step3.vue";

function getFields() {
  return formFields(
    [
      "name",
      "event",
      "integration_id",
      "command",
      // "segmentation_list",
      "tags",
      "values",
      "billet_url",
      "offer",
      "machine_code",
      "sequence_code",
      "sequence_level_code"
    ],
    {
      values: ["email", "name"]
    }
  );
}

export default {
  components: {
    Step2ActiveCampaign,
    Step2LeadLovers,
    Step3,
    Step1,
    Resume
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    product_id: {
      type: [Number, String],
      default: null
    },
    eventToEdit: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ...getFields(),
      visible: false,
      loading: false,
      step: 1,
      steps: ["", "", "", ""]
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) this.clear();
    },
    eventToEdit(v) {
      if (v) {
        const machine_code = get(v, "namespace", "");
        const sequence_code = get(v, "tag_id", "");
        const sequence_level_code = get(v, "metadata.sequence_level", "");
        this.form = {
          ...this.form,
          ...v,
          integration_id: v.integration,
          machine_code: !!machine_code ? Number(machine_code) : machine_code,
          sequence_code: !!sequence_code
            ? Number(sequence_code)
            : sequence_code,
          sequence_level_code: !!sequence_level_code
            ? Number(sequence_level_code)
            : sequence_level_code,
          tag: get(v, "tags.tag", "")
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents", "providers", "mapProviderName"]),
    ...mapState("product", ["products"]),
    provider() {
      return this.providers.find(({ id }) => id == this.form.integration_id);
    },
    isLeadLovers() {
      return this?.provider?.name === "leadlovers";
    },
    isActiveCampaign() {
      return this?.provider?.name === "active_campaign";
    },
    isRDStation() {
      return this?.provider?.name === "rdstation";
    },
    title() {
      const defaultMsg = "Criar segmentação";
      if (this.form.event && this.typeEvents.length) {
        const event = this.typeEvents.find(p => p.id === this.form.event);

        if (!event) return defaultMsg;

        return event.name;
      }

      return defaultMsg;
    },
    description() {
      const defaultMsg = "Configuração inicial";
      if (this.form.integration_id && this.providers.length) {
        const provider = this.providers.find(
          p => p.id === this.form.integration_id
        );

        if (!provider) return defaultMsg;

        return `Conta: ${this.mapProviderName[provider.name]}`;
      }
      return defaultMsg;
    },
    isValid() {
      if (this.step === 1) {
        if (this?.provider?.name == "leadlovers")
          return this.form.name && !!this.form.integration_id;

        return !!this.form.integration_id;
      }

      if (this.step === 2) {
        if (this?.provider?.name == "leadlovers") {
          return (
            this.form.machine_code &&
            this.form.sequence_code &&
            this.form.sequence_level_code
          );
        }

        return !!this.form.name;
      }

      if (this.step === 3) {
        return this.form.event && this.form.command;
      }

      return true;
    },
    cancelLabel() {
      return this.step === 1 ? "Cancelar" : "Voltar";
    },
    submitLabel() {
      return this.step === 4 ? "Salvar segmentação" : "Próximo";
    },
    isSignature() {
      const product = this.products.find(
        p => p.id === parseInt(this.product_id)
      );
      return get(product, "type_product") === "signature";
    }
  },
  methods: {
    clear(integration_id = "") {
      this.step = 1;
      const { form, errors } = getFields();
      this.errors = { ...errors };
      this.form = { ...form, integration_id };
    },
    onSuccess() {
      this.$message.success("A segmentação foi salva!");
      this.visible = false;
      this.clear();
      this.$emit("refresh");
    },
    submit() {
      this.loading = true;

      const payload = {
        product_id: this.product_id,
        ...this.form
      };

      if (this.provider.name == "leadlovers") {
        payload.metadata = { sequence_level: this.form.sequence_level_code };
        payload.namespace = this.form.machine_code;
        payload.tag_id = this.form.sequence_code;
        payload.tags = { tag: this.form.tag };
      }

      if (this.eventToEdit) {
        this.$store
          .dispatch("integration/putEvents", {
            ...payload,
            id: this.eventToEdit.id
          })
          .then(this.onSuccess)
          .catch(error => {
            this.$message.error("Erro ao salvar segmentação");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch("integration/postEvents", payload)
          .then(this.onSuccess)
          .catch(error => {
            this.$message.error("Erro ao salvar a nova segmentação");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    next() {
      if (this.step < 4) {
        if (this.step === 1 && this.isRDStation) {
          this.step = 2;
          return;
        }
        this.step += 1;
        return;
      }

      if (this.step === 4) {
        this.submit();
      }
    },
    previous() {
      if (this.step === 1) {
        this.visible = false;
        return;
      }

      if (this.step >= 2) {
        if (this.step === 3 && this.isRDStation) {
          this.step = 1;
          return;
        }
        this.step -= 1;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-leadlist {
  ::v-deep {
    .form-group {
      padding: 0;
      margin-top: 16px;
      label {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 4px;
        color: #736d80;
      }
      .el-input__inner,
      .form-control {
        border: 1px solid #c4c0cc;
        min-height: 40px;
        height: 40px;
      }
    }
  }
  .submit-buttons {
    gap: 16px;
    display: flex;
    margin-top: 32px;
    justify-content: flex-end;
    @media screen and (max-width: 991px) {
      flex-direction: column;
    }
    .btn {
      padding: 12px 24px;
    }
    .btn-secondary {
      order: 0;
      @media screen and (max-width: 991px) {
        order: 1;
      }
      border: none;
      color: #57586be0;
      background-color: rgba(119, 120, 142, 0.08) !important;
    }
    .btn-primary {
      order: 1;
      @media screen and (max-width: 991px) {
        order: 0;
      }
      border: none;
      background-color: #781effe0;
    }
  }
  .step-indicator-wrapper {
    gap: 4px;
    display: flex;
    align-items: center;
    .step-indicator {
      background: #dec8ffd9;
      border-radius: 24px;
      transition: 0.2s all;
      width: 10px;
      height: 8px;
      &.done {
        background: #008f2bdd;
      }
      &.active {
        background: #781effe0;
        border-radius: 6px;
        width: 24px;
      }
    }
  }
}
</style>
